import {Icon, IconProps} from '@chakra-ui/react';

export function GroundMarksIcon(props: IconProps) {
  return (
    <Icon width="inherit" height="inherit" viewBox="0 0 566 459" fill="none" {...props}>
      <mask
        id="mask0_2694_22392"
        style={{maskType: 'alpha'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="566"
        height="459"
      >
        <rect
          x="0.903973"
          y="0.906475"
          width="564.462"
          height="457.462"
          fill="#C4C4C4"
          stroke="white"
          strokeWidth="0.538415"
        />
      </mask>
      <g mask="url(#mask0_2694_22392)">
        <path
          d="M287.373 456.592C287.373 458.964 285.468 460.883 283.122 460.883C280.777 460.883 278.872 458.964 278.872 456.592C278.872 454.221 280.777 452.302 283.122 452.302C285.468 452.302 287.373 454.221 287.373 456.592Z"
          fill="white"
          stroke="white"
          strokeWidth="0.538415"
        />
        <path
          d="M18.1208 0.63722C18.1208 10.3973 10.2807 18.2893 0.634281 18.2893C-9.01215 18.2893 -16.8522 10.3973 -16.8522 0.63722C-16.8522 -9.12289 -9.01215 -17.0149 0.634281 -17.0149C10.2807 -17.0149 18.1208 -9.12289 18.1208 0.63722Z"
          stroke="white"
          strokeWidth="2.69207"
        />
        <path
          d="M583.096 0.6371C583.096 10.3972 575.256 18.2892 565.61 18.2892C555.963 18.2892 548.123 10.3972 548.123 0.6371C548.123 -9.12301 555.963 -17.015 565.61 -17.015C575.256 -17.015 583.096 -9.12301 583.096 0.6371Z"
          stroke="white"
          strokeWidth="2.69207"
        />
      </g>
      <path
        d="M358.453 456.592C358.453 414.623 324.727 380.6 283.123 380.6C241.519 380.6 207.793 414.623 207.793 456.592"
        stroke="white"
        strokeWidth="2.69207"
      />
      <rect x="118.743" y="1.9833" width="328.76" height="134.094" stroke="white" strokeWidth="2.69207" />
      <rect x="239.271" y="1.9833" width="87.704" height="42.9034" stroke="white" strokeWidth="2.69207" />
      <path
        d="M287.374 96.3877C287.374 98.7594 285.469 100.678 283.123 100.678C280.778 100.678 278.873 98.7594 278.873 96.3877C278.873 94.016 280.778 92.0974 283.123 92.0974C285.469 92.0974 287.374 94.016 287.374 96.3877Z"
        fill="white"
        stroke="white"
        strokeWidth="0.538415"
      />
      <mask id="path-9-inside-1_2694_22392" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M200.259 133.624C214.377 165.425 246.024 187.579 282.8 187.579C319.576 187.579 351.223 165.425 365.341 133.624H200.259Z"
        />
      </mask>
      <path
        d="M200.259 133.624V130.932H196.118L197.798 134.716L200.259 133.624ZM365.341 133.624L367.802 134.716L369.482 130.932H365.341V133.624ZM282.8 184.887C247.137 184.887 216.426 163.405 202.719 132.532L197.798 134.716C212.329 167.445 244.911 190.271 282.8 190.271V184.887ZM362.881 132.532C349.174 163.405 318.463 184.887 282.8 184.887V190.271C320.689 190.271 353.271 167.445 367.802 134.716L362.881 132.532ZM365.341 130.932H200.259V136.316H365.341V130.932Z"
        fill="white"
        mask="url(#path-9-inside-1_2694_22392)"
      />
      <path
        d="M1.84604 5.88655C1.84604 3.65635 3.65397 1.84842 5.88415 1.84842H560.116C562.346 1.84842 564.154 3.65635 564.154 5.88653V457.156H1.84604V5.88655Z"
        stroke="white"
        strokeWidth="2.69207"
      />
    </Icon>
  );
}
